export default {
  LIST: {
    TITLE: `Listes de contact`,
    SUMMARY: ``
  },
  VIEW: {
    TITLE: `Liste de contact`
  },
  STATUSES: {
    PAUSED: `Arrêtée`,
    CREATING: `En cours de création`,
    PENDING: `En attente`,
    RUNNING: `En cours`,
    CREATED: `Créée`,
    ARCHIVED: `Archivée`
  },
  CONTACT_USER_HISTORY_MODAL: {
    TITLE: `Historique de {{ name }}`,
    SUMMARY: ``
  },
  CONTACT_USERS_HISTORY_MODAL: {
    TITLE: `Historique de contact pour les membres de la liste`,
    TITLE_other: ``,
    SUMMARY: ``,
    SEEING_THESE_USERS: `Vous voyez l'historique de contact pour {{ count }} utilisateurs de la liste :`,
    LOADING_DATA: `Chargement des historiques`
  },
  CONTACT_LIST_HISTORY_MODAL: {
    TITLE: `Historique de la liste`,
    SUMMARY: ``
  },
  CONTACT_USER_PRIORITY_MODAL: {
    TITLE: `Changer la priorité pour {{ name }}`,
    SUMMARY: ``,
    PRIORITY: {
      LABEL: `Nouvelle priorité`,
      PLACEHOLDER: `Entrez un chiffre pour la priorité`,
      DESCRIPTION: `Sert à réordonner les utilisateurs dans une liste de contact, l'utilisateur sera placé devant l'utilisateur qui avait le numéro de priorité choisi.`
    }
  },
  CONTACT_USER_HOURS_OFFERED_MODAL: {
    TITLE: `Changer le nombre d'heures offertes pour {{ name }}`,
    SUMMARY: ``,
    NUMBEROFHOURSOFFERED: {
      LABEL: `Nombre d'heures offertes`,
      PLACEHOLDER: `Entrez un nombre`,
      DESCRIPTION: `Sert à ajuster le nombre d'heures offertes à un utilisateur dans une liste. Peut être négatif afin d'ajuster la somme totale d'heures.`
    }
  },
  CONTACT_USER_TIMES_CONTACTED_MODAL: {
    TITLE: `Changer le nombre de fois contactés pour {{ name }}`,
    SUMMARY: ``,
    NUMBEROFTIMESCONTACTED: {
      LABEL: `Nouveau nombre de contacts`,
      PLACEHOLDER: `Entrez un nombre`,
      DESCRIPTION: `Sert à ajuster le nombre de contacts fait à un utilisateur dans une liste. À utiliser si vous avez contacté l'utilisateur sans utiliser le système.`
    }
  },
  CONTACT_USER_SHIFT_ELIGIBILITY_MODAL: {
    TITLE: `Voir l'éligibilité pour {{ name }}`,
    SUMMARY: `Ce modal vous permet de changer l'éligibilité d'un utilisateur à des quarts de travail dans une liste de contact.`,
    ELIGIBLE: `Éligible`,
    ELIGIBLE_FORCED_BY: `Éligible, forcé par {{ forcedBy }}`,
    NOT_ELIGIBLE: `Non éligible`,
    NOT_ELIGIBLE_FORCED_BY: `Non éligible, forcé par {{ forcedBy }}`,
    MAKE_NOT_ELIGIBLE: `Rendre non éligible`,
    MAKE_ELIGIBLE: `Rendre éligible`,
    ERROR_SAVING_ELIGIBILITY: `Erreur en sauvegardant l'éligibilité`
  },
  CONTACT_USER_ADD_HISTORY_MODAL: {
    TITLE: `Ajouter un événement pour {{ name }}`,
    SUMMARY: ``,
    ERROR_SAVING_ENTRY: `Il y a eu une erreur en sauvegardant l'événement.`,
    PLEASE_SELECT_SHIFT: `Veuillez choisir le quart de travail que l'utilisateur a accepté.`,
    CONTACT_INFO: `Informations de contact`,
    SELECT_SHIFT: `Selectionner`,
    SHIFT_SELECTED: `Selectionné`,
    REFUSED_DESCRIPTION: `Ce choix de résultat enlevera l'utilisateur de tous les quarts acceptés dans la liste et les remettra disponible.`,
    STATUS: {
      LABEL: `Type d'événement`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Sert à indiquer de quelle manière s'est produit l'événement.`
    },
    ANSWER: {
      LABEL: `Résultat`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Sert à indiquer le résultat de l'événement.`
    },
    COMMENT: {
      LABEL: `Commentaire`,
      PLACEHOLDER: `Ajoutez un commentaire descriptif`,
      DESCRIPTION: `Sert à ajouter plus d'information, ce champ est requis lorsque le type d'événement voir notes est sélectionné.`
    }
  },
  CONTACT_LIST_SETTINGS_MODAL: {
    TITLE: `Modification des paramètres de la liste`,
    SUMMARY: `Sert à déterminer comment la liste sera gérée par le système.`,
    MAXACTIVECALLS: {
      LABEL: `Nombre maximal d'appels en cours`,
      PLACEHOLDER: `Veuillez entrer un nombre supérieur à 0`,
      DESCRIPTION: `Sert à limiter le nombre d'appels effectués en même temps. Si la valeur est plus élevée que celle des appels en attente, le plus petit numéro sera utilisé afin d'empêcher le système d'excéder le nombre maximal d'appels en attente.`
    },
    MAXCONCURRENTCALLS: {
      LABEL: `Nombre maximal d'appels en attente`,
      PLACEHOLDER: `Veuillez entrer un nombre supérieur à 0`,
      DESCRIPTION: `Sert à limiter le nombre d'utilisateurs dans la liste pouvant avoir un délai de rappel en même temps.`
    },
    ACTIVATECONCURRENTCALLSRATIO: {
      LABEL: `Activer le ratio des appels en attente`,
      DESCRIPTION: `Sert à déterminer quel ratio d'appels en attente est permis par rapport aux quarts de travail non assignés restants.`
    },
    CONCURRENTCALLSRATIO: {
      LABEL: `Ratio maximal d'appels en attente`,
      PLACEHOLDER: `Veuillez entrer un nombre supérieur à 0`,
      DESCRIPTION: `Les ratios peuvent ne pas être un nombre entier.`
    }
  },
  CREATE_LIST_MODAL: {
    TITLE: `Creation d'une liste de contact`,
    SUMMARY: `Ceci permettra la distribution rapide de quarts à vos employés éligibles.`,
    ERROR_LOADING: `Quarts de travail non disponibles.`,
    ERROR_NO_VALID_EVENTS: `Aucun quart de travail valide reçu, veuillez vous assurer de sélectionner au moins un quart de travail ne faisant pas déjà partie d'une liste.`,
    ERROR_NO_AVAILABLE_CONFIGS: `Aucune configuration de liste disponible, veuillez demander à votre administrateur d'en configurer.`,
    ERROR_CREATING_LIST: `Il y a eu une erreur en créant la liste, veuillez ressayer.`,
    NOT_ALL_SAME_DAY: `Certains quarts de travail sélectionnés n'était pas à la même date, ils ont étés filtrés.`,
    NOT_ALL_OUT_OF_LIST: `Certains quarts de travail sélectionnés faisaient déjà partie d'une liste, ils ont étés filtrés.`,
    LISTCONFIGID: {
      LABEL: `Choissisez la configuration à utiliser`,
      DESCRIPTION: `Sert à déterminer quels utilisateurs seront éligibles et l'ordre dans lequel ils seront placés.`
    },
    SHOULDMERGE: {
      LABEL: `Fusionner avec une liste existante`,
      DESCRIPTION: `Sert à déterminer s'il faut créer une nouvelle liste ou fusionner avec une liste existante.`
    },
    MERGEWITH: {
      LABEL: `Liste avec laquelle fusionner`,
      DESCRIPTION: `Sert à déterminer la liste à laquelle il faut ajouter les quarts de travail.`
    },
    ADDOTHERSHIFTS: {
      LABEL: `Ajouter les autres quarts non assignés, absences et congés du jour à la liste.`,
      DESCRIPTION: ``
    }
  },
  START_CONTACT_LIST_CONFIRMATION_MODAL: {
    TITLE: `Démarrer la liste de contact`,
    SUMMARY: `Êtes-vous sûr de vouloir démarrer la liste de contact? les utilisateurs éligibles commenceront à reçevoir des appels.`
  },
  LIST_HISTORY: {
    ARCHIVED_LIST: `<0>{{ name }}</0> a archivé la liste {{ date }} à <1>{{ time }}</1>.`,
    PAUSED_LIST: `<0>{{ name }}</0> a arrêté la liste {{ date }} à <1>{{ time }}</1>.`,
    STARTED_LIST: `<0>{{ name }}</0> a démarré la liste {{ date }} à <1>{{ time }}</1>.`,
    RESUMED_LIST: `<0>{{ name }}</0> a reparti la liste {{ date }} à <1>{{ time }}</1>.`,
    APPROVED_LIST: `<0>{{ name }}</0> a changé le statut d'approbation de la liste {{ date }} à <1>{{ time }}</1>.`,
    APPROVED_SHIFT: `<0>{{ name }}</0> a changé le statut d'approbation d'un quart {{ date }} à <1>{{ time }}</1>.`,
    MERGED_SHIFTS: `<0>{{ name }}</0> a fusionné des quarts dans la liste {{ date }} à <1>{{ time }}</1>.`,
    ADDED_CONTACT_TEMPLATE: `<0>{{ name }}</0> a ajouté un modèle de notification {{ date }} à <1>{{ time }}</1>.`,
    REMOVED_CONTACT_TEMPLATE: `<0>{{ name }}</0> a enlevé un modèle de notification{{ date }} à <1>{{ time }}</1>.`
  },
  HISTORY: {
    BY: `par`,
    'IN-PROGRESS': `En cours`,
    COMPLETE_IN_PERSON: `Complété en personne`,
    COMPLETE_OVER_PHONE: `Complété au téléphone`,
    OTHER_NOTES: `Autre, voir notes`,
    SET_MANUALLY: `Fait manuellement`,
    BACKUP_CALL_SCHEDULED: `Deuxième appel planifié`,
    NO_DELAY: `Aucun délai`,
    NOTE: `Note`,
    BUSY: `Ligne occupée`,
    ACCEPTED: `Accepté`,
    REFUSED: `Refusé`,
    LEFT_MESSAGE: `Message laissé`,
    OTHER_PERSON_ACCEPTED: `Autre personne a accepté`,
    OTHER_PERSON_REFUSED: `Autre personne a refusé`,
    OTHER_PERSON_LEFT_MESSAGE: `Message laissé à une autre personne`,
    NO_ANSWER: `Aucune réponse`,
    NO_SERVICE: `Aucun service`,
    NOT_AVAILABLE_ACCEPTED: `Aucun quart de travail disponible`,
    NOT_AVAILABLE_REFUSED: `Aucun quart de travail disponible`,
    CONTACTED_BY_MISTAKE: `Contacté par erreur`,
    BUMPED: `Bumpé`,
    SHOULD_CALL: `Devrait être appelé`,
    SHOULD_NOT_CALL: `Ne devrait pas être appelé`,
    CHANGED_PRIORITY: `Priorité`,
    CHANGED_NUMBER_OF_TIMES_CONTACTED: `Nombre de fois où l'employé a été contacté`,
    CHANGED_NUMBER_OF_HOURS_OFFERED: `Le nombre d'heures offertes`,
    NO_SHIFTS_TO_OFFER: `Aucun quart de travail à offrir`,
    NO_PHONE_NUMBER: `Aucun numéro de contact`,
    NO_PUSH_NOTIFICATIONS: `Notifications push désactivées`,
    DID_NOT_CALL_BACK: `N'a pas rappelé dans son délai`,
    USER_ARCHIVED: `Est archivé`,
    WAITING: `En attente`,
    COMPLETED: `Complété`,
    ALREADY_ACCEPTED: `Déjà accepté`,
    CALLED_BACK: `A rappelé`,
    TEXTED_BACK: `A répondu par message texte`,
    NOT_CALLED: `N'a pas été appelé ou texté`,
    NOT_CONTACTED: `N'a pas été contacté`,
    CALL_STARTED: `Appel commencé`,
    CHECKED_MESSAGES_APP: `A consulté ses offres dans l'application`,
    RINGING: `Sonnerie`,
    IN_PROGRESS: `En cours`,
    FAILED: `Échec`,
    PUSH_NOTIFICATION_SENT: `Notification push envoyée`,
    TEXT_MESSAGE_SENDING: `Message texte en cours d'envoi`,
    TEXT_MESSAGE_SENT: `Message texte envoyé`,
    TEXT_MESSAGE_DELIVERED: `Message texte délivré`,
    TEXT_MESSAGE_UNDELIVERED: `Message texte non délivré`,
    TEXT_MESSAGE_FAILED: "Échec d'envoi du message texte",
    HUNG_UP: `A raccroché`,
    HUNG_UP_AGAIN: `A encore raccroché`,
    CALLING_OTHER_NUMBER: `Appel sur un autre numéro`,
    CALL_DURATION: `Durée de l'appel`,
    MERGED_LIST: `Mise à jour des offres de quart après fusion des listes`,
    MERGED_LIST_WITH_SHIFTS: `Un nouveau quart de travail à offrir`,
    MERGED_LIST_NO_SHIFTS: `Pas de nouveaux quarts de travail à offrir`,
    undefined: `NA`
  },
  ARCHIVE_BUTTON: {
    TITLE: `Archiver la liste de contact`,
    SUMMARY: `Ceci archivera définitivement la liste de contact, il ne sera plus possible d'intéragir avec mais les informations resteront disponibles.`,
    USERNAME_REQUIRED: `Entrez votre nom d'utilisateur afin de continuer`,
    PRIMARY_ACTION: `Archiver la liste de contact`
  },
  DELETE_BUTTON: {
    TITLE: `Supprimer la liste de contact`,
    SUMMARY: `Etes-vous certain de vouloir supprimer la liste de contact?`,
    PRIMARY_ACTION: `Supprimer la liste de contact`,
    USERNAME: {
      LABEL: `Nom d'utilisateur`,
      PLACEHOLDER: `Entrer votre nom d'utilisateur pour archiver la liste`,
      DESCRIPTION: ``
    }
  },
  WORKING_TODAY: `Travaille aujourd'hui ({{ shifts }})`,
  ON_TIME_OFF: `En congé aujourd'hui ({{timeOffs}})`,
  ON_LEAVE: `Est absent aujourd'hui ({{attendances}})`,
  ALL_DAY_LONG: `Toute la journée`,
  STARTING_AT: `À partir de {{start}}`,
  ENDING_AT: `Jusqu'à {{end}}`,
  IS_AVAILABLE: `Est disponible`,
  IS_NOT_AVAILABLE: `N'est pas disponible`,
  MAKE_NOT_AVAILABLE: `Rendre indisponible`,
  MAKE_AVAILABLE: `Rendre disponible`,
  TAKEN_BY: `Accepté par {{ takenBy }}`,
  NO_USERS_ELIGIBLE: `Aucun utilisateur éligible`,
  USERS_ELIGIBLE: `{{ count }} utilisateur éligible `,
  USERS_ELIGIBLE_other: `{{ count }} utilisateurs éligibles`,
  NOT_CONTACTED_YET: `N'as pas encore été contacté`,
  ELIGIBLE_FOR_UNAPPROVED_SHIFTS: `Éligible pour des quarts non-approuvés`,
  NOT_ELIGIBLE: `N'est pas éligible`,
  CALLBACK_DELAY: `a {{ delay }} pour rappeller`,
  OPTIONS: `Options`,
  ADD_HISTORY_EVENT: `Ajouter un événement`,
  MARK_SHOULD_NOT_CALL: `Changer à ne pas appeler`,
  MARK_SHOULD_CALL: `Changer à appeler`,
  CHANGE_PRIORITY: `Changer la priorité`,
  PAUSE_LIST_AT_THIS_USER: `Arrêter la liste ici`,
  UNPAUSE_LIST_AT_THIS_USER: `Reprendre la liste ici`,
  PAUSE_LIST_AT_THIS_USER_DESCRIPTION: `La liste s'arrêtera à cet employé.`,
  ADJUST_NUMBER_OF_TIMES_CONTACTED: `Ajuster le nombre de fois contactés`,
  ADJUST_NUMBER_OF_HOURS_OFFERED: `Ajuster le nombre d'heures offertes`,
  VIEW_HISTORY: `Voir l'historique`,
  VIEW_SHIFT_ELIGIBILITY: `Voir l'éligibilité aux quarts`,
  SUMMARY: `Sommaire`,
  STATUS: `Statut`,
  CREATIONDATE: `Date de création`,
  SHIFTS: `Quarts de travail`,
  ACTIVE_CALLS: `Appels en cours`,
  CONCURRENT_CALLS: `Appels en attente`,
  GROUPED_LIST: `Liste groupée`,
  ACTIVE_CALLS_SUMMARY: `{{ count }} appel en cours sur un maximum de {{ maxActiveCalls }}`,
  ACTIVE_CALLS_SUMMARY_other: `{{ count }} appels en cours sur un maximum de {{ maxActiveCalls }}`,
  CONCURRENT_CALLS_SUMMARY: `{{ count }} appel en attente sur un maximum de {{ maxConcurrentCalls }}`,
  CONCURRENT_CALLS_SUMMARY_other: `{{ count }} appels en attente sur un maximum de {{ maxConcurrentCalls }}`,
  START: `Démarrer`,
  RESUME: `Reprendre`,
  PAUSE: `Arrêter`,
  ARCHIVE: `Archiver`,
  DELETE: `Supprimer`,
  SEE_HISTORY: `Voir l'historique de la liste`,
  REPORT_PDF: `Exporter la liste en PDF`,
  REPORT_CSV: `Exporter la liste en CSV`,
  SETTINGS: `Paramètres de la liste`,
  NUMBER_OF_TIMES_CONTACTED: `A été contacté {{ count }} fois dans ce type de liste.`,
  NUMBER_OF_TIMES_CONTACTED_other: `A été contacté {{ count }} fois dans ce type de liste.`,
  NUMBER_OF_HOURS_OFFERED: `S'est fait offrir {{ count }} heure dans ce type de liste.`,
  NUMBER_OF_HOURS_OFFERED_other: `S'est fait offrir {{ count }} heures dans ce type de liste.`,
  ALL_SHIFTS_DELETED: `Tous les quarts de travail qui étaient dans la liste ont étés supprimés.`,
  NOTIFICATIONS: `Notifications`,
  DELETE_NOTIFICATION_TEMPLATE: `Supprimer le modèle`,
  EDIT_NOTIFICATION_TEMPLATE: {
    TITLE: `Modification d'un modèle de notifications`,
    SUMMARY: `Les modèles de notifications vous permettent de rapidement sélectionner un groupe d'utilisateurs à notifier.`
  },
  CREATE_NOTIFICATION_TEMPLATE: {
    TITLE: `Création d'un modèle de notifications`,
    SUMMARY: `Les modèles de notifications vous permettent de rapidement sélectionner un groupe d'utilisateurs à notifier.`
  },
  SHIFTSLIST: `{{ count }}/{{totalShifts}} quart assigné.`,
  SHIFTSLIST_other: `{{ count }}/{{totalShifts}} quarts assignés.`,

  notificationTemplate: {
    SELECT_USER_TO_ADD_CONTACTS: `Choissisez un utilisateur afin de l'ajouter dans les contacts`,
    NAME_MANDATORY: `Vous devez entrer un nom.`,
    ACTIVATE_TEMPLATES: `Activer un modèle`,
    ACTIVATE_TEMPLATE: `Activer <0>{{ name }}</0>`,
    DISABLE_TEMPLATE: `Désactiver <0>{{ name }}</0>`,
    CREATE_NEW_TEMPLATE: `Créer un nouveau modèle de notifications`,
    MANAGE_TEMPLATES: `Modèles de notifications`,
    EDIT_TEMPLATE: `Modifier <0>{{ name }}</0>`,
    NAME: {
      LABEL: `Nom`,
      PLACEHOLDER: `Entrez un nom`,
      DESCRIPTION: `Le nom devrait permettre de rapidement identifier le modèle.`
    },
    CONTACTS: {
      LABEL: `Contacts`,
      DESCRIPTION: `Sert à déterminer qui sera contacté et par quelle méthode lorsque la liste roule.`
    },
    ISDEFAULT: {
      LABEL: `Par défaut`,
      DESCRIPTION: `Ce modèle de notifications sera actif sur toutes les nouvelles listes.`
    }
  },
  export: {
    TITLE: `Rapport de liste de contact`,
    GENERATED_BY: `Généré par`,
    CREATED_THE: `Crée le`,
    FOR_THE: `Pour le`,
    BY: `Par`,
    FIRSTNAME: `Prénom`,
    LASTNAME: `Nom`,
    POSITION: `Position`,
    START: `Début`,
    END: `Fin`,
    DATE: `Date`,
    ELIGIBLE: `Éligible`,
    REASON: `Raison`,
    TAKEN_BY: `Pris par`,
    ANSWER: `Réponse`,
    STATUS: `Statut`,
    COMMENT: `Commentaire`,
    DONE_BY: `Fait par`,
    TIME: `Heure`,
    FILE_NAME: `rapport_liste_contact_{{ dates }}`,
    EMPLOYEE: `Employé`,
    EMPLOYEENUMBER: `Numéro d'employé`,
    NUMBEROFHOURSOFFERED: `Nombre d'heures offertes`,
    NUMBEROFTIMESCONTACTED: `Nombre de fois contacté`,
    TOTALNUMBEROFHOURSEOFFERED: `Nombre total d'heures offertes`,
    TOTALNUMBEROFTIMESCONTACTED: `Nombre total de fois contacté`,
    CALL_DURATION: `Durée d'appel`,
    CSV_FILE_NAME: `historique_de_contact_{{shortListId}}`
  },
  EVENT_SUMMARY: `<0>{{ positionName }}</0> <1>{{ start }} - {{ end }})</1>`,
  SEE_CONTACT_HISTORY_THIS_PAGE: `Voir l'historique des utilisateurs pour cette page`,
  SEE_CONTACT_HISTORY: `Voir l'historique des utilisateurs pour le filtre actuel`,
  EXPORT_CONTACT_HISTORY_THIS_PAGE: `Exporter l'historique des utilisateurs de cette page (CSV)`,
  EXPORT_CONTACT_HISTORY: `Exporter l'historique des utilisateurs pour le filtre actuel (CSV)`,
  TWILIO_NOT_OPERATIONAL: `Il semble y avoir un problème avec notre fournisseur d'appels et messages textes. Il se peut qu'il n'y ait aucun impact sur les listes de contact, mais vous pouvez contact notre support pour vous en assurer avant de partir une liste.`,
  LIST_NOT_FINISHED_CREATING: `Cette liste n'a pas encore fini d'être crée. Ceci peut prendre de quelques minutes. La page rafraîchira automatiquement lorsque la liste sera créée.`,
  LIST_UNAPPROVED: `Cette liste n'a pas encore été approuvée. Elle ne sera pas lancée tant qu'elle ne sera pas approuvée.`
}
